import React from 'react';
import Card from '../../../../Presentation/components/ui/Card';
import {AppText, AppSectionTitle} from '../../../../Presentation/components/ui/Typography';
import {CreateRoleForm} from '../forms/CreateRoleForm';
import {X} from 'lucide-react';
import StandardizedErrorHandler from '../../../../Services/common/StandardizedErrorHandler';

interface CreateRoleModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (roleData: {
    name: string;
    displayName: string;
    description: string;
  }) => Promise<void>;
  loading?: boolean;
}

export const CreateRoleModal: React.FC<CreateRoleModalProps> = ({
  open,
  onClose,
  onSubmit,
  loading = false
}) => {
  if (!open) {return null;}

  const handleSubmit = async (roleData: {
    name: string;
    displayName: string;
    description: string;
  }) => {
    try {
      await onSubmit(roleData);
      onClose();
    } catch (error) {
      // Handle error using StandardizedErrorHandler to show server message
      StandardizedErrorHandler.getInstance().handleError(error, 'CreateRoleModal.handleSubmit');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="w-full max-w-6xl max-h-[90vh] overflow-y-auto">
        <Card className="relative">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <AppSectionTitle className="font-semibold text-gray-900">
              إنشاء دور جديد
            </AppSectionTitle>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              disabled={loading}
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <CreateRoleForm
              onSubmit={handleSubmit}
              onCancel={onClose}
              loading={loading}
            />
          </div>
        </Card>
      </div>
    </div>
  );
};
